import React from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert } from '../../components/Alert';
import { AlertNotificationTypes } from '../../components/AlertNotification';
import { EXPRESIONES_INPUTS, Input } from '../../components/Input';
import { ModalConfirmar } from '../../components/ModalConfirmar';
import { ModalPortal } from '../../components/ModalPortal';
import { authService } from '../../services/auth';
import { appDataActions } from '../../store/appData/appDataActions';
import { EN_DEMO, MSG_DEMO } from '../../utils/demo';

export const CambiarPassModal = () => {
    const defaultValuesInputs = {
        password: "",
        RePassword: "",
    }

    const [show, setShow] = useState(false)

    const [fetchError, setFetchError] = useState();
    const [isFetching, setIsFetching] = useState(false);

    const [inputsForm, setInputsForm] = useState(defaultValuesInputs);
    const [formError, setFormError] = useState({});
    const [validated, setValidate] = useState(false);

    const [showConfirmacion, setShowConfirmacion] = useState(false)

    const dispatch = useDispatch();

    const handleCloseConfirmacion = () => {
        setShowConfirmacion(false)
    }

    const handleShowConfirmacion = () => {
        setShowConfirmacion(true)
    }

    const isMountedSignalRef = useRef();

    const handleShow = (event) => {
        event.stopPropagation();
        setInputsForm(defaultValuesInputs)
        setFetchError(null)
        setValidate(false)
        setShow(true)
    }

    const handleClose = () => {
        setShow(false)
    }

    const handleClickActualizar = async (evento) => {
        setValidate(true)

        if (!(Object.keys(formError).length > 0)) {
            setFetchError("")
            setIsFetching(true)

            let modifyValues = {};
            const allKeys = Object.keys(defaultValuesInputs);
            allKeys.forEach(ctKey => { if (defaultValuesInputs[ctKey] != inputsForm[ctKey]) modifyValues[ctKey] = inputsForm[ctKey] })

            try {
                await authService.editAccount(modifyValues, isMountedSignalRef.current);
                dispatch(appDataActions.showAlertNotification("Tu datos fueron actualizados correctamente", `Bien!`, AlertNotificationTypes.SUCCESS))
                handleClose();
            }
            catch (err) {
                const erroresMap = err.errores;
                let erroresFormated;
                if (erroresMap) {
                    const erroresKeys = Object.keys(erroresMap);
                    erroresFormated = {}
                    erroresKeys.forEach(ctKey => {
                        erroresFormated[ctKey] = erroresMap[ctKey].msg
                    });
                } else {
                    erroresFormated = err.message
                }
                setFetchError(erroresFormated)
            }
            finally {
                setIsFetching(false)
            }
        }
        handleCloseConfirmacion()
    }


    useEffect(() => {
        const abortController = new AbortController();
        isMountedSignalRef.current = abortController.signal;
        return () => abortController.abort();
    }, [])

    return (
        <>
            <button className="btn-secondary" onClick={handleShow}>Cambiar contraseña</button>

            <ModalPortal
                show={show}
                onClose={handleClose}
                title={`Cambiar contraseña:`}
                size={"sm"}
                modalContentStyle={{ paddingBottom: "1rem" }}
                footer={
                    <>
                        <div className="modal__btn-container">
                            <button className="btn-primary" onClick={handleShowConfirmacion} disabled={EN_DEMO} title={EN_DEMO ? MSG_DEMO : undefined}>Cambiar</button>
                            <ModalConfirmar
                                show={showConfirmacion}
                                onClose={handleCloseConfirmacion}
                                onConfirm={handleClickActualizar}
                                textConfirm={"¿Deseas cambiar tu contraseña?"}
                            />
                            <button id="modal-volver" className="btn-secondary" disabled={isFetching}>Volver</button>
                        </div>
                    </>
                }

            >
                <Alert type="warning" style={{ marginTop: "4px" }}>
                    {fetchError}
                </Alert>

                <form>
                    <div className="input-with-title">
                        <p>Nueva contraseña</p>
                        <Input
                            name="password"
                            required
                            inputsForm={inputsForm}
                            setInputsForm={setInputsForm}
                            formError={formError}
                            setFormError={setFormError}
                            validated={validated}
                            placeholder="Contraseña*"
                            expReg={EXPRESIONES_INPUTS.PASSWORD}
                            type="password"
                            disabled={isFetching}
                            backgroundColorDark
                        />
                    </div>
                    <div className="input-with-title">
                        <p>Repetir nueva contraseña</p>
                        <Input
                            name="RePassword"
                            required
                            inputsForm={inputsForm}
                            setInputsForm={setInputsForm}
                            formError={formError}
                            setFormError={setFormError}
                            validated={validated}
                            placeholder="Repetir contraseña*"
                            sameValueThat={inputsForm["password"]}
                            type="password"
                            disabled={isFetching}
                            backgroundColorDark
                        />
                    </div>
                </form>
            </ModalPortal>
        </>
    )
}